<template>
  <div class="popup-wrapper" :class="{ 'showing': modal }">
    <div class="popup-card p25">
      <div class="d-flex justify-content-between align-items-center">
        <div class="font-bold">Cancel</div>
        <button @click="$emit('close-modal')" class="btn btn-for-close"><span class="icon-ico-close"></span></button>
      </div>
      <div class="inner-land">
        <div class="popup-item">
          <div class="row gap-2">
            <FormCancelStatus @cancel="onCancel" v-model="data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCancelStatus from './Form/Cancel.vue'
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
export default {
  name: '',
  components: {
    FormCancelStatus
  },
  props: ['modal', 'detail'],
  data() {
    return {
      data: {
        status: 'cancel',
        revision: ''
      }
    }
  },
  methods: {
    async onCancel() {
      try {
        await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, this.data)
        this.$store.dispatch('getDetailFeedbackComplaintInternalIssue', this.$route.params.id)
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
        this.$emit('close-modal')
      } catch (error) {
        showErrorMessage(error)
      }
    },
    async onClose(statusLabel) {
      try {
        if (statusLabel == 'Outstanding Internal & Customer - Waiting For Verification Tech Mkt Supp Manager') {
          // run customer close first before internal issue
          await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
            status: 'closed',
          })
        }
        await axios.put(`/fnc-internal-issues/${this.$route.params.id}`, {
          status: 'closed',
        })
        this.$store.dispatch('getDetailFeedbackComplaintInternalIssue', this.$route.params.id)
        this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
        this.$emit('close-modal')
      } catch (error) {
        showErrorMessage(error)
      }
    },
  }
}
</script>
